import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { ViewLogService } from './services/view-log.service';
import { JedsMenuService } from '@shared/services/app/menu.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-view-log',
  templateUrl: './view-log.component.html',
  styleUrls: ['./view-log.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [ //Animacion para expandir/cerrar string de maniobra
    trigger('panelState', [
      state('closed', style({ height: '20px', overflow: 'hidden' })),
      state('open', style({ height: '*' })),
      transition('closed <=> open', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]), fuseAnimations
  ]
})
export class ViewLogComponent implements OnInit {


  // para evitar multiples llamados.
  private timeoutId: any;
  // Filtros 
  @Input() filterComponent: any = undefined;
  private formComponent: any;
  private filtercomponent: string = '';
  private filterLike: string;
  private filterPaginado: string = '&per-page=10&page=0';
  @Input() FiltersLikes: string[] = [];
  @Input() extraParams: string = '';
  // ssp o client, con esto se designa si se utilizara o no paginado del lado del servidor
  @Input() renderType: string;
  @Input() functions: any[];
  // para realizar el sort cuando se hace SSP (server side pagination) 
  private sortSSP: string = '';
  // dataSource:                           MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() columnsNames: string[] = ['ID', 'Usuario', 'Accion', 'Fecha', 'Informacion'];
  @Input() columnsParams: string[] = ['id', 'username', 'action', 'date', 'data'];
  @Input() accionesButtons: string[];
  @Input() accionesFunctions: string[];
  @Input() endpoint: string = null;
  @Input() startSort: string = '';
  @Output() functionEmitter = new EventEmitter<{ name: string, params: any }>();
  dataSource: MatTableDataSource<any>;
  pageSize: number = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  expanded: string = 'closed';
  expandedElements: any[] = [];
  constructor(private service: ViewLogService, @Optional() @Inject(MAT_DIALOG_DATA) private data: any, private menuService: JedsMenuService) {

    if (data) {
      this.endpoint = data.endpoint;
      this.extraParams = data.extraParams;
      this.renderType = data.renderType;

      this.accionesButtons = data.accionesButtons;
      this.accionesFunctions = data.accionesFunctions;
      this.functions = data.functions;
      if (data.columnsNames && data.columnsParams) {
        this.columnsNames = data.columnsNames;
        this.columnsParams = data.columnsParams;
      }
    }

    if (!this.columnsNames) {
      this.columnsNames = this.columnsParams;
    }
  }

  emitFunction(name: string, params: any) {
    this.functionEmitter.emit({ name, params });
  }

  ngOnInit(): void {
    this.renderTabla();
    this.dataSource = new MatTableDataSource<any>();
  }


  noAfterViewInit() {
    if (!!this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }

    this.sort.sortChange.subscribe((sort: Sort) => {
      if (this.renderType == 'ssp') {
        let column = sort.active;
        switch (sort.direction) {
          case "asc":
            this.sortSSP = `=${column}`;
            break;
          case "desc":
            this.sortSSP = `=-${column}`;
            break
          default:
            this.sortSSP = '';
            break;
        }
        this.renderTabla();
      }
    });
  }

  //Funcion para expandir el string de la descripcion de la maniobra.
  toggleExpand(id: number) {
    let exist = this.expandedElements.findIndex(m => m === id);
    (exist < 0) ? this.expandedElements.push(id) : this.expandedElements.splice(exist, 1);
    return (exist < 0) ? 'open' : 'closed';
  }

  isExpanded(id: number) {
    return this.expandedElements.find(m => m === id) ? 'open' : 'closed';
  }


  renderTabla() {
    let query = ``;
    if (this.sortSSP != '') { // sortSSP va a ser vacio si el renderType es client. Caso contrario (SSP) puede tener valor
      query = `?sort${this.sortSSP}`
    } else {
      if (this.startSort != '') {
        query = `?sort=${this.startSort}`
      } else {
        query = `?sort=-id`
      }
    }
    if (this.endpoint) {
      if (this.extraParams != '') {
        let arr_filters = this.extraParams.split('&');
        if (this.extraParams.length != 0 && arr_filters.length > 0) {
          arr_filters.forEach(filter => {
            filter.startsWith('[') ? query += '&filter' + filter + '' : query += '&' + filter + '';
          })
        }
      }
      if (this.filterComponent) {
        query += this.filtercomponent
      }
      if (this.filterLike) {
        query += this.filterLike
      }
      if (this.renderType != 'client') {
        query += this.filterPaginado
      }
      this.service.getData(this.endpoint, query).subscribe(r => {
        this.dataSource = new MatTableDataSource<any>(r.data);
        this.paginator.length = r.totalCount;
        if (this.renderType == 'client') {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
    }
  }

  cambioPagina(event: any) {
    this.filterPaginado = `&per-page=${event.pageSize}&page=${event.pageIndex + 1}`
    this.renderTabla();
  }


  /**
   * Esta funcion es para el buscador de input, recibe un string y renderiza la tabla
   * @param input 
   */
  filters(input: string) {
    if (input == '') {
      this.filterLike = ''
    } else {
      this.filterLike = input
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId); //Limpio el temporizador evita multiples llamadas
    }
    this.timeoutId = setTimeout(() => {
      let query = ''
      for (let i = 0; i < this.FiltersLikes.length; i++) {
        const like = this.FiltersLikes[i];
        query += `&filter[${like}][like]=${this.filterLike}`
      }
      this.filterLike = query;
      this.renderTabla();
    }, 750);
  }

  /**
   * 
   * Funcion para acceder a multi nivel con expands
   * 
   * @param element una fila de la respuesta 
   * @param column el string de atributo para acceder
   * @returns el parametro en formato de string.
   */
  parse(element: any, column: string): string {
    let colSplit = column.split('.');
    let temp = element
    let err: boolean = false
    for (let i = 0; i < colSplit.length && !err; i++) {
      const propiedad = colSplit[i];
      temp = temp[propiedad]
      if (!temp) {
        err = true
        temp = '-'
      }
    }
    return temp
  }

  modalUp(documentRef: MatButton) {
    this.menuService
      .open(this.filterComponent, documentRef._elementRef, this.formComponent)
      .afterClosed()
      .subscribe({
        next: data => {
          if (data) {
            this.filtercomponent = data.filter
            this.formComponent = data.form

            this.renderTabla()
          }
        },
      });
  }
}

